import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { fetchApi } from "../../../../utlis/axios";
import Loader from "../../../Loader/Loader";
import { IoIosSend, IoMdClose } from "react-icons/io";
import {
  FaDownload,
  FaInfoCircle,
  FaRegFile,
  FaRegFlag,
  FaSortAmountUp,
  FaUserCircle,
} from "react-icons/fa";
import { GrAttachment } from "react-icons/gr";
import { MdDeleteForever } from "react-icons/md";
import RichTextEditor1 from "../CommentTextEditor";
import { addToast } from "../../../../Redux/Slices/toast-slice";
import { PiCalendarDuotone } from "react-icons/pi";
import { IoCheckmarkDoneCircleOutline } from "react-icons/io5";
import { LuInfo } from "react-icons/lu";
import { FaRegFilePdf } from "react-icons/fa6";

const TicketView = ({
  ticketDetail,
  handleClose,
  isTicketFetching,
  handleEditTicket,
  setTicketDetails
}) => {
  const { theme } = useSelector((state) => state.theme);
  const { userInfo } = useSelector((state) => state.auth);
  const users = useSelector((state) => state.allUsers?.filterUsers);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let isFetched = useRef(false);
  const modalRef = useRef(null);
  const [editorOpen, setEditorOpen] = useState(false);
  const { id } = useParams();
  const [ticketData, setTicketData] = React.useState({
    created_at: "",
    title: "",
    description: "",
    priority: "",
    sprint: "",
    type: "",
    developer: {},
    project: {},
    milestone: {},
    comments: [],
    attachment: [],
  });
  const [comment, setComment] = React.useState("");
  const [comments, setComments] = useState([]);
  const [description, setDescription] = useState("");
  const [title, setTitle] = useState("");
  const [commentDescription, setCommentDescription] = useState("");
  const [editingCommentId, setEditingCommentId] = useState(null);
  const [editingAttachments, setEditingAttachments] = useState([]);
  const fileInputRef = useRef(null);
  const fileInputRef1 = useRef(null);
  const [preview, setPreview] = useState(null);
  const [attachmentPreview, setAttachmentPreview] = useState(null);
  const [attachments, setAttachments] = useState([]);
  const [uploadedFile, setUploadedFile] = useState([]);
  const [fileUploading, setFileUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [commentDeleting, setCommentDeleting] = useState(null);
  const [isDeleting, setDeleting]=useState(false)
  const [isCommentEditing, setIsCommentEditing]=useState(false)
  const [isAttachmentUplaoding, setIsAttachmentUploading]=useState(false)
  const [commentSending, setCommentSending] = useState(false);

  useEffect(() => {
    if (ticketDetail) {
      setComments(ticketDetail.comments || []);
      setAttachments(ticketDetail.attachment || []);
    }
  }, [ticketDetail]);

  const updatTicket = async () => {
    try {
      const res = await fetchApi.get(`project-tickets/${ticketDetail?.id}/`, {
        headers: { Authorization: `Bearer ${userInfo.access_token}` },
      });
      if (res.status === 200) {
        const result = res.data;
        setTicketData({
          created_at: result.created_at,
          title: result.title,
          description: result.description,
          type: result.type,
          priority: result.priority,
          sprint: result.sprint,
          project: result.project,
          milestone: result.milestone,
          developer: result.developer,
          comments: result.comments,
          attachment: result.attachment,
        });
        setTitle(result.title);
        setDescription(res.data.description);
        setComments(res.data.comments);
        setAttachments(res.data.attachment);
      }
    } catch (error) {}
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (fileUploading) {
      dispatch(addToast({ message: "File uploading...", type: "warn" }));
      return;
    }
    setCommentSending(true);
    try {
      const formData = new FormData();
      if (uploadedFile) {
        const formattedComments = Array.isArray(uploadedFile)
          ? uploadedFile
          : [uploadedFile];
        formattedComments.forEach((comment) => {
          formData.append("attachment[]", comment); // Adjust based on API requirements
        });
      }
      if (!comment) {
        formData.append("description", "no description");
      } else {
        formData.append("description", comment);
      }
      formData.append("created_by", userInfo?.user.id);
      const res = await fetchApi.post(`comments/`, formData, {
        headers: { Authorization: `Bearer ${userInfo.access_token}` },
      });
      if (res.status === 201) {
        setUploadedFile(null);
        setComment("");
        setPreview(null);
        addComment(res.data.id, res.data);
      }
    } catch (error) {
      dispatch(addToast({ message: error.message, type: "error" }));
    }finally{
      setCommentSending(false);
    }
  };
  const addComment = async (cid, newComm) => {
    try {
      let previousComments = [];
      if (comments?.length > 0) {
        comments.map((e) => previousComments.push(e?.id));
      }
      const res = await fetchApi.patch(
        `project-tickets/${ticketDetail?.id}/`,
        { comments: [...previousComments, cid] },
        {
          headers: { Authorization: `Bearer ${userInfo.access_token}` },
        }
      );
      if (res.status === 200) {
        updatTicket();
        dispatch(addToast({ message: "Comment added", type: "success" }));
      }
    } catch (error) {
      dispatch(addToast({ message: error.message, type: "error" }));
    }
  };
  function timeDifference(dateString) {
    const givenDate = new Date(dateString); // Parse the given date
    const currentDate = new Date(); // Get the current date
    const diffInMilliseconds = currentDate - givenDate; // Difference in milliseconds

    // Calculate time differences
    const diffInSeconds = Math.floor(diffInMilliseconds / 1000);
    const diffInMinutes = Math.floor(diffInMilliseconds / (1000 * 60));
    const diffInHours = Math.floor(diffInMilliseconds / (1000 * 60 * 60));
    const diffInDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));
    const diffInMonths = Math.floor(
      diffInMilliseconds / (1000 * 60 * 60 * 24 * 30)
    );
    const diffInYears = Math.floor(
      diffInMilliseconds / (1000 * 60 * 60 * 24 * 365)
    );

    if (diffInSeconds < 60) {
      return `${diffInSeconds} seconds ago`;
    } else if (diffInMinutes < 60) {
      return `${diffInMinutes} minutes ago`;
    } else if (diffInHours < 24) {
      return `${diffInHours} hours ago`;
    } else if (diffInDays < 30) {
      return `${diffInDays} days ago`;
    } else if (diffInMonths < 12) {
      return `${diffInMonths} months ago`;
    } else {
      return `${diffInYears} year${diffInYears > 1 ? "s" : ""} ago`;
    }
  }

  const handleButtonClick = () => {
    fileInputRef.current.click(); // Trigger the hidden file input
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0]; // Get the selected file

    if (file) {
      // Show file preview (for images)
      if (file.type.startsWith("image/")) {
        const reader = new FileReader();
        reader.onload = () => setPreview(reader.result);
        reader.readAsDataURL(file);
      } else {
        setPreview(file.name); // Show the file name for non-image files
      }

      // Simulate file upload
      const formData = new FormData();
      formData.append("file", file);
      setFileUploading(true);
      try {
        const response = await fetchApi.post("/attachments/", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${userInfo.access_token}`,
          },
        });

        if (response.status === 201) {
          setUploadedFile(response.data.id);
        } else {
          dispatch(addToast({ message: "File upload failed", type: "error" }));
        }
      } catch (error) {
        dispatch(addToast({ message: error.message, type: "error" }));
      } finally {
        setFileUploading(false);
      }
    }
  };
  const handleButtonClick1 = () => {
    fileInputRef1.current.click(); // Trigger the hidden file input
  };

  const handleFileChange1 = async (event) => {
    const file = event.target.files[0]; // Get the selected file

    if (file) {
      // Show file preview (for images)
      if (file.type.startsWith("image/")) {
        const reader = new FileReader();
        reader.onload = () => setAttachmentPreview(reader.result);
        reader.readAsDataURL(file);
      } else {
        setAttachmentPreview(file.name); // Show the file name for non-image files
      }

      // Simulate file upload
      const formData = new FormData();
      formData.append("file", file);
      formData.append("created_by", userInfo?.user.id);
      setIsAttachmentUploading(true)
      try {
        const response = await fetchApi.post("/attachments/", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${userInfo.access_token}`,
          },
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setUploadProgress(percentCompleted); // Update state to display progress
          },
        });
        setUploadProgress(0);
        if (response.status === 201) {
          const newAttachment = response.data.id;
          const newAttachmentFile = response.data;
          let previousAttachments = [];
          if (attachments.length > 0) {
            attachments.map((e) => previousAttachments.push(e?.id));
          }
          try {
            const res = await fetchApi.patch(
              `project-tickets/${ticketDetail.id}/`,
              { attachment: [...previousAttachments, newAttachment] },
              {
                headers: { Authorization: `Bearer ${userInfo.access_token}` },
              }
            );
            if (res.status === 200) {
              setAttachmentPreview(null);
              setAttachments((previousAttachments) => [
                ...previousAttachments,
                newAttachmentFile,
              ]);
              dispatch(addToast({ message: "File uploaded", type: "success" }));
            }
          } catch (error) {
            dispatch(addToast({ message: error.message, type: "error" }));
          }
        } else {
          dispatch(addToast({ message: "File upload failed", type: "error" }));
        }
      } catch (error) {
        dispatch(addToast({ message: error.message, type: "error" }));
        setUploadProgress(0);
      }finally{
        setIsAttachmentUploading(false);
      }
    }
  };

  const handleDeleteComment = async (commentId) => {
    setCommentDeleting(commentId);
    try {
      // Step 1: Remove the comment ID from the ticket's comment list
      const remainingComments = comments
        .filter((e) => e.id !== commentId)
        .map((e) => e.id);

      const updateTicketRes = await fetchApi.patch(
        `project-tickets/${id}/`,
        { comments: remainingComments },
        {
          headers: { Authorization: `Bearer ${userInfo.access_token}` },
        }
      );

      if (updateTicketRes.status === 200) {
        updatTicket();
        dispatch(addToast({ message: "Comment removed", type: "success" }));
        setComments((prevComments) =>
          prevComments.filter((comment) => comment.id !== commentId)
        );
        removeFromDb(commentId);
      } else {
        dispatch(
          addToast({ message: "Failed to remove comment", type: "error" })
        );
      }
    } catch (error) {
      dispatch(addToast({ message: error.message, type: "error" }));
    } finally {
      setCommentDeleting(null);
    }
  };
  const removeFromDb = async (commentId) => {
    try {
      const deleteCommentRes = await fetchApi.delete(`comments/${commentId}/`, {
        headers: { Authorization: `Bearer ${userInfo.access_token}` },
      });
    } catch (error) {}
  };
  const handleEditClick = (comment) => {
    setEditingCommentId(comment.id); // Set the comment ID being edited
    setCommentDescription(comment.description); // Set the description for editing
    setEditingAttachments([...comment.attachment]); // Copy the attachments for editing
  };

  const handleDeleteAttachment = async (attachmentId, commentId) => {
    try {
      // Filter out the attachment to remove from the local state first
      setEditingAttachments((prev) =>
        prev.filter((a) => a.id !== attachmentId)
      );

      // Prepare the updated attachment list
      const updatedAttachments = editingAttachments
        .filter((attachment) => attachment.id !== attachmentId)
        .map((attachment) => attachment.id);

      // Update the comment's attachments on the server
      const patchResult = await fetchApi.patch(
        `comments/${commentId}/`,
        { attachment: updatedAttachments },
        {
          headers: { Authorization: `Bearer ${userInfo.access_token}` },
        }
      );
      updatTicket();
      // If PATCH is successful, delete the attachment
      if (patchResult.status === 200) {
        await fetchApi.delete(`attachments/${attachmentId}/`, {
          headers: { Authorization: `Bearer ${userInfo.access_token}` },
        });
      } else {
        throw new Error("Failed to update comment's attachments.");
      }
    } catch (error) {
      console.error("Error deleting attachment:", error);
    }
  };
  const handleRemoveAttachment = async (attachmentId) => {
    try {
      const updatedAttachments = attachments
        .filter((attachment) => attachment.id !== attachmentId)
        .map((attachment) => attachment.id);

      // Update the comment's attachments on the server
      const patchResult = await fetchApi.patch(
        `project-tickets/${ticketDetail.id}/`,
        { attachment: updatedAttachments },
        {
          headers: { Authorization: `Bearer ${userInfo.access_token}` },
        }
      );
      if (patchResult.status === 200) {
        setAttachments((prev) => prev.filter((a) => a.id !== attachmentId));
        removeAttachment(attachmentId);
      }
    } catch (error) {
      dispatch(
        addToast({ message: "Error deleting attachment", type: "error" })
      );
    }
  };
  const removeAttachment = async (attachmentId) => {
    try {
      await fetchApi.delete(`attachments/${attachmentId}/`, {
        headers: { Authorization: `Bearer ${userInfo.access_token}` },
      });
    } catch (error) {
      console.error(error);
    }
  };
 

  const handleDeleteTicket = async () => {
    setDeleting(true)
    try {
      const updateTicketRes = await fetchApi.delete(`project-tickets/${id}/`, {
        headers: { Authorization: `Bearer ${userInfo.access_token}` },
      });

      if (updateTicketRes.status === 204) {
        dispatch(
          addToast({ message: "Tickets deleted successfully", type: "success" })
        );
        handleClose()
      } else {
        dispatch(addToast({ message: "Failed to delete", type: "error" }));
      }
    } catch (error) {
      dispatch(addToast({ message: error.message, type: "error" }));
    }finally{
setDeleting(false)
    }
  };

  const getFileType = (fileName) => {
    if (!fileName) return "other";
    const extension = fileName.split(".").pop().toLowerCase();
    const imageTypes = ["jpg", "jpeg", "png", "gif", "webp"];
    const videoTypes = ["mp4", "webm", "ogg"];
    const pdfType = ["pdf"];

    if (imageTypes.includes(extension)) return "image";
    if (videoTypes.includes(extension)) return "video";
    if (pdfType.includes(extension)) return "pdf";
    return "other";
  };

  const getFirstMediaAttachment = () => {
    if (!attachments?.length) return null;
    return attachments.find((file) => {
      const fileType = getFileType(file.file);
      return fileType === "image" || fileType === "video";
    });
  };

  const getRemainingAttachments = () => {
    const firstMedia = getFirstMediaAttachment();
    if (!firstMedia) return attachments;
    return attachments.filter((file) => file.id !== firstMedia.id);
  };

  function getFileName(url) {
    if (!url) return "";
    const parts = url.split("/");
    return parts[parts.length - 1];
  }

  const handleClickOutside = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      handleClose();
      setTicketDetails(null);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-50 z-[1000] "></div>
      <div className="w-full h-full max-h-[100vh] overflow-y-scroll z-[1010] inset-0 fixed px-4 py-4 ">
        <div className="flex min-h-full items-center justify-center w-full">
          <div className="flex items-center justify-center w-full ">
            <div
              ref={modalRef}
              className={`max-w-[768px] w-full py-6 px-8 rounded-[20px] shadow-xl my-10 ${
                theme === "dark"
                  ? "bg-[#1E1E1E] text-white"
                  : "bg-[#F9FAFB] text-black"
              }`}
            >
              {isTicketFetching ? (
                <div className="min-h-[300px] min-w-[380px] flex items-center justify-center">
                  <Loader />
                </div>
              ) : !ticketDetail ? (
                <div className="min-h-[300px] flex items-center justify-center">
                  <p className="text-gray-500 dark:text-gray-400">
                    No ticket details available.
                  </p>
                </div>
              ) : (
                <>
                  {/* Header with first media attachment preview */}
                  <div className="w-full">
                    <div className="justify-end items-center flex  w-full">
                      <button
                        onClick={handleClose}
                        className={`p-2 mb-2  rounded-full ${
                          theme === "dark"
                            ? "text-white bg-gray-800"
                            : "text-black bg-gray-200"
                        }`}
                      >
                        <IoMdClose className="w-6 h-6" />
                      </button>
                    </div>

                    {/* Show first media attachment if exists */}
                    {(() => {
                      const firstMedia = getFirstMediaAttachment();
                      if (!firstMedia) return null;

                      const fileType = getFileType(firstMedia.file);
                      return (
                        <div className="relative w-full h-[300px] bg-gray-100 dark:bg-gray-800">
                          {fileType === "image" ? (
                            <div className="relative w-full h-full group">
                              <img
                                src={firstMedia.file}
                                alt="Attachment preview"
                                className="w-full h-full object-cover"
                                style={{ margin: 0 }}
                              />
                              <div className="absolute top-2 right-2 flex gap-2 opacity-0 group-hover:opacity-100 transition">
                                <a
                                  href={firstMedia.file}
                                  download
                                  className="p-2 rounded-full bg-gray-800 text-white hover:bg-gray-700"
                                >
                                  <FaDownload className="w-4 h-4" />
                                </a>
                                <button
                                  onClick={() =>
                                    handleRemoveAttachment(firstMedia.id)
                                  }
                                  className="p-2 rounded-full bg-red-600 text-white hover:bg-red-700"
                                >
                                  <MdDeleteForever className="w-4 h-4" />
                                </button>
                              </div>
                            </div>
                          ) : (
                            <div className="relative w-full h-full">
                              <video
                                src={firstMedia.file}
                                controls
                                className="w-full h-full object-contain"
                              />
                              <div className="absolute top-2 right-2 flex gap-2">
                                <a
                                  href={firstMedia.file}
                                  download target="_blank"
                                  className="p-2 rounded-full bg-gray-800 text-white hover:bg-gray-700"
                                >
                                  <FaDownload className="w-4 h-4" />
                                </a>
                                <button
                                  onClick={() =>
                                    handleRemoveAttachment(firstMedia.id)
                                  }
                                  className="p-2 rounded-full bg-red-600 text-white hover:bg-red-700"
                                >
                                  <MdDeleteForever className="w-4 h-4" />
                                </button>
                              </div>
                            </div>
                          )}
                        </div>
                      );
                    })()}

                    {/* Title */}
                    <div className="flex justify-center items-center mt-4">
                      <h2 className="text-2xl font-semibold">
                        {ticketDetail?.title}
                      </h2>
                    </div>
                  </div>

                  {/* Ticket Details Grid */}
                  <div className="grid grid-cols-2 md:grid-cols-3 gap-6 mt-4">
                    <div className="flex items-center gap-3">
                      {ticketDetail?.developer?.picture ?
                      <img
                        src={
                          ticketDetail?.developer?.picture ||
                          "/default-avatar.png"
                        }
                        alt="Assigned To"
                        className="w-8 h-8 rounded-full"
                      /> : <FaUserCircle className="w-8 h-8 rounded-full text-gray-500"/>}
                      <div>
                        <p className="text-sm text-gray-500 dark:text-gray-400">
                          Assigned To
                        </p>
                        <p className="font-medium dark:text-white">
                          {ticketDetail?.developer?.first_name}{" "}
                          {ticketDetail?.developer?.last_name}
                        </p>
                      </div>
                    </div>
                    <div className="flex items-center gap-2">
  <div className={`p-1 rounded-full border flex items-center `}>
    <IoCheckmarkDoneCircleOutline className="w-6 h-6"/>
  </div>
                    <div>
                      <p className="text-sm text-gray-500 dark:text-gray-400">
                        Sprint
                      </p>
                      <p className="font-medium dark:text-white">
                        Sprint {ticketDetail?.sprint}
                      </p>
                    </div>
                    </div>
                    <div className="flex items-center gap-2">
                      <div
                        className={`p-1 rounded-full border flex items-center `}
                      >
                        <LuInfo  className="w-6 h-6" />
                      </div>
                      <div>
                        <p className="text-sm text-gray-500 dark:text-gray-400">
                          Type
                        </p>
                        <p className="font-medium dark:text-white capitalize">
                          {ticketDetail?.type}
                        </p>
                      </div>
                    </div>
                    <div className="flex items-center gap-2">
                      <div
                        className={`p-1 rounded-full border flex items-center `}
                      >
                        <PiCalendarDuotone className="w-6 h-6" />
                      </div>
                      <div>
                        <p className="text-sm text-gray-500 dark:text-gray-400">
                          Start Date
                        </p>
                        <p className="font-medium dark:text-white">
                          {new Date(
                            ticketDetail?.started_at
                          ).toLocaleDateString()}
                        </p>
                      </div>
                    </div>
                    <div className="flex items-center gap-2">
                      <div
                        className={`p-1 rounded-full border flex items-center `}
                      >
                        <FaSortAmountUp className="w-6 h-6" />
                      </div>
                      <div>
                        <p className="text-sm text-gray-500 dark:text-gray-400">
                          Priority
                        </p>
                        <div className="flex items-center gap-2">
                          <span
                            className={`px-2 py-1 rounded-full text-xs ${
                              ticketDetail?.priority === "high"
                                ? "bg-red-100 text-red-600"
                                : ticketDetail?.priority === "medium"
                                ? "bg-yellow-100 text-yellow-600"
                                : "bg-green-100 text-green-600"
                            }`}
                          >
                            {ticketDetail?.priority}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center gap-2">
                      <div
                        className={`p-1 rounded-full border flex items-center `}
                      >
                        <FaRegFlag className="w-6 h-6" />
                      </div>
                      <div>
                        <p className="text-sm text-gray-500 dark:text-gray-400">
                          Milestone
                        </p>
                        <p className="font-medium dark:text-white">
                          {ticketDetail?.milestone?.title}
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Description */}
                  <div>
                    <h3 className="text-lg font-semibold mb-2 mt-4">
                      Ticket Description
                    </h3>
                    <div
                      className={` rounded-lg p-4 mt-2 border ${
                        theme === "dark"
                          ? "bg-[#212529] border-[#555657]"
                          : "bg-[#F2F4F7] border-[#9A9F9A]"
                      }`}
                    >
                      <div
                        dangerouslySetInnerHTML={{
                          __html: ticketDetail?.description,
                        }}
                        className="prose dark:prose-invert max-w-none"
                      />
                    </div>
                  </div>

                  {/* Attachments */}
                  <div className="mt-4">
                    <div className="flex items-center justify-between mb-4">
                      <h3 className="text-lg font-semibold dark:text-white">
                        Attachments
                      </h3>
                      <button
                        className="heroButton"
                        onClick={handleButtonClick1} disabled={isAttachmentUplaoding}
                      >
                        {isAttachmentUplaoding ? "Uploading..." :'+ Add'}
                        <input
                          type="file"
                          ref={fileInputRef1}
                          style={{ display: "none" }}
                          onChange={handleFileChange1}
                        />
                      </button>
                    </div>
                    <div className="grid grid-cols-1 gap-4">
                      {getRemainingAttachments().map((file, index) => {
                        const fileType = getFileType(file.file);

                        return (
                          <div
                            key={index}
                            className="group relative bg-gray-50 dark:bg-gray-800 rounded-lg overflow-hidden"
                          >
                            {fileType === "image" && (
                              <div className="relative aspect-video">
                                <img
                                  src={file.file}
                                  alt={file.name}
                                  className="w-full h-full object-cover"
                                />
                                <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-40 transition-all duration-300" />
                                <div className="absolute top-2 right-2 flex gap-2 opacity-0 group-hover:opacity-100 transition-all duration-300">
                                  <a
                                    href={file.file}
                                    download target="_blank"
                                    className="p-2 rounded-full bg-gray-800 text-white hover:bg-gray-700"
                                  >
                                    <FaDownload className="w-4 h-4" />
                                  </a>
                                  <button
                                    onClick={() =>
                                      handleRemoveAttachment(file.id)
                                    }
                                    className="p-2 rounded-full bg-red-600 text-white hover:bg-red-700"
                                  >
                                    <MdDeleteForever className="w-4 h-4" />
                                  </button>
                                </div>
                              </div>
                            )}

                            {fileType === "video" && (
                              <div className="relative aspect-video">
                                <video
                                  src={file.file}
                                  controls
                                  className="w-full h-full object-cover"
                                />
                                <div className="absolute top-2 right-2 flex gap-2">
                                  <a
                                    href={file.file}
                                    download target="_blank"
                                    className="p-2 rounded-full bg-gray-800 text-white hover:bg-gray-700"
                                  >
                                    <FaDownload className="w-4 h-4" />
                                  </a>
                                  <button
                                    onClick={() =>
                                      handleRemoveAttachment(file.id)
                                    }
                                    className="p-2 rounded-full bg-red-600 text-white hover:bg-red-700"
                                  >
                                    <MdDeleteForever className="w-4 h-4" />
                                  </button>
                                </div>
                              </div>
                            )}

                            {fileType === "pdf" && (
                              <div className={`p-4 flex items-center justify-between  ${
                        theme === "dark"
                          ? "bg-[#212529] border-[#555657]"
                          : "bg-[#F2F4F7] border-[#9A9F9A]"
                      }`}>
                                <div className="flex items-center gap-3">
                                  <FaRegFilePdf className="w-6 h-6" />
                                  <span className="dark:text-white truncate">
                                    {getFileName(file.file)}
                                  </span>
                                </div>
                                <div className="flex gap-2">
                                  <a
                                    href={file.file}
                                    download target="_blank"
                                    className="text-blue-600 hover:text-blue-700"
                                  >
                                    <FaDownload className="w-4 h-4" />
                                  </a>
                                  <button
                                    onClick={() =>
                                      handleRemoveAttachment(file.id)
                                    }
                                    className="text-red-600 hover:text-red-700"
                                  >
                                    <MdDeleteForever className="w-4 h-4" />
                                  </button>
                                </div>
                              </div>
                            )}

                            {fileType === "other" && (
                              <div className={`p-4 flex items-center justify-between  ${
                        theme === "dark"
                          ? "bg-[#212529] border-[#555657]"
                          : "bg-[#F2F4F7] border-[#9A9F9A]"
                      }`}>
                                <div className="flex items-center gap-3">
                                  <FaRegFile className="w-6 h-6" />
                                  <span className="dark:text-white truncate">
                                    {getFileName(file.file)}
                                  </span>
                                </div>
                                <div className="flex gap-2">
                                  <a
                                    href={file.file}
                                    download
                                    className="text-blue-600 hover:text-blue-700"
                                  >
                                    <FaDownload className="w-4 h-4" />
                                  </a>
                                  <button
                                    onClick={() =>
                                      handleRemoveAttachment(file.id)
                                    }
                                    className="text-red-600 hover:text-red-700"
                                  >
                                    <MdDeleteForever className="w-4 h-4" />
                                  </button>
                                </div>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  {/* Activity/Comments */}
                  <div className="mt-4">
                    <h3 className="text-lg font-semibold mb-4 ">Activity</h3>
                    {/* Comment Input */}
                    <div className="flex gap-2">
                      {userInfo?.user?.picture ? 
                      <img
                        src={userInfo?.user?.picture || "/default-avatar.png"}
                        alt=""
                        className="w-8 h-8 rounded-full object-cover"
                      /> : <FaUserCircle className="w-8 h-8 rounded-full object-cover text-gray-500"/>}
                      {!isCommentEditing ? 
                      <div className={`bg-transparent outline-none border p-2 rounded-[10px] w-full ${theme === 'dark' ?'border-gray-600':'border-gray-400'}`} type="text" onClick={()=>setIsCommentEditing(true)}>
                    Write comment here
                      </div> : 
                      <div className="flex">
                        <div className="border dark:border-gray-700 rounded-lg flex items-end gap-1">
                          <RichTextEditor1
                            comment={comment}
                            setComment={setComment}
                          />
                          <div className="flex justify-center gap-2 items-center pr-2 pb-2 ">
                            <div>
                              <button onClick={handleButtonClick}>
                                <GrAttachment className="w-4 h-4" />
                              </button>
                              <input
                                type="file"
                                ref={fileInputRef}
                                style={{ display: "none" }} // Hide the file input
                                onChange={handleFileChange}
                              />
                            </div>
                            <button
                              onClick={handleSubmit}
                              className="px-4 py-2 heroButton text-white rounded-lg hover:bg-red-700"
                            >
                              {commentSending ? 'Sending...':'Send'}
                            </button>
                          </div>
                        </div>
                      </div> }
                    </div>
                    <div className="space-y-4 mb-4 mt-4">
                      {comments?.map((comment) => (
                        <div key={comment.id} className="flex gap-4">
                          <div className="flex gap-2">
                            <>
                              {comment.created_by?.picture ? (
                                <img
                                  src={
                                    comment.created_by?.picture ||
                                    "/default-avatar.png"
                                  }
                                  alt=""
                                  className="w-8 h-8 object-cover rounded-full"
                                />
                              ) : (
                                <FaUserCircle className="w-8 h-8 text-gray-500" />
                              )}
                            </>
                            <div>
                              <span className="font-medium flex items-center gap-1">
                                {comment.created_by?.first_name}{" "}
                                {comment.created_by?.last_name}
                              </span>
                              <span className="text-sm text-gray-500">
                                {new Date(comment.created_at).toLocaleString()}
                              </span>
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: comment.description,
                                }}
                                className="font-medium"
                              />
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Footer Actions */}
                  <div className="flex item-center justify-center items-center w-full pt-4  p-6 gap-4 font-medium">
                    <button
                      onClick={() => handleDeleteTicket()} disabled={isDeleting}
                      className="px-6 py-2 border border-gray-300 dark:border-gray-600 w-1/3 rounded-full hover:bg-gray-50 dark:hover:bg-gray-800"
                    >
                      {isDeleting ? 'Deleting...' :'Delete'}
                    </button>
                    <button
                      onClick={() => handleEditTicket(ticketDetail)}
                      className="px-6 py-2 w-1/3 heroButton hover:bg-red-700"
                    >
                      Edit Ticket
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TicketView;
